import { createSlice } from "@reduxjs/toolkit";
import { clear } from "../session/sessionSlice";

const initialState = {
  ...JSON.parse(localStorage.getItem("systemParams")),
};

const systemParamsSlice = createSlice({
  name: "systemParams",
  initialState,
  reducers: {
    set: (state, action) => {
      localStorage.setItem("systemParams", JSON.stringify(action.payload));
      return { ...state, ...action.payload };
    },
    setOutpuFormats: (state, action) => {
      return { ...state, outputformats: action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(clear, (state) => {
      localStorage.setItem("systemParams", null);
      return { printerOptions: state.printerOptions };
    });
  },
});

export const { set, setOutpuFormats } = systemParamsSlice.actions;

export default systemParamsSlice.reducer;
